import { Editable, EditableInput, EditablePreview, useToast } from "@chakra-ui/react";

import { PatientTaskInstanceId } from "../../../../shared/schema/schema";
import { useUpdatePatientTaskInstanceNotes } from "../actions/taskActions";

type Props = {
  notes: string | null;
  taskInstanceId: PatientTaskInstanceId;
};

export default function TasksNewNotesCell({ notes, taskInstanceId }: Props) {
  const toast = useToast();
  const updateNotesMutation = useUpdatePatientTaskInstanceNotes();

  const handleSubmit = (value: string) => {
    const normalized = value.trim() === "" ? null : value.trim();
    if (normalized === notes) {
      return;
    }
    updateNotesMutation.mutate(
      { notes: normalized, taskInstanceId },
      {
        onError: () =>
          toast({ description: "Failed to save note", status: "error", title: "Notes" }),
      }
    );
  };

  return (
    <Editable
      key={notes ?? ""}
      defaultValue={notes ?? ""}
      isDisabled={updateNotesMutation.isPending}
      minW="140px"
      placeholder="Add note…"
      selectAllOnFocus={false}
      onSubmit={handleSubmit}
    >
      <EditablePreview
        color={notes ? undefined : "gray.400"}
        w="full"
        onMouseDown={(e) => {
          // suppress the browser's click caret placement so the input's
          // onFocus below controls where the caret lands
          e.preventDefault();
          e.currentTarget.focus();
        }}
      />
      <EditableInput
        onFocus={(e) => {
          // always start editing with the caret at the end of the text
          const el = e.currentTarget;
          el.setSelectionRange(el.value.length, el.value.length);
        }}
      />
    </Editable>
  );
}
